module.exports = __webpack_public_path__ + "static/img/not-found.f64e8ac2.png";